import { inject, Pipe, PipeTransform } from '@angular/core';
import { StoreService } from '../services/store.service';

@Pipe({
	name: 'custImage',
})
export class CustImagePipe implements PipeTransform {
	_ss = inject(StoreService);

	imageDomain = this._ss.CustomerInformation.CustImageDomain;

	transform(imageField: string): string {
		const domain = this.imageDomain || this._ss.CustomerInformation.CustImageDomain || '';
		return `${domain}/${encodeURIComponent(imageField)}.jpg`;
	}
}
